import PropTypes from "prop-types";
import styles from "./upgradeCheckBar.module.scss";
import config from "../../../config/index";
import CTAButton from "../CTAButton/CTAButton";

const UpgradeCheckBar = (props) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const imgUrl = props.btnLabel
    ? `${imagePrefix}/assets/images/upgrade-info.svg`
    : `${imagePrefix}/assets/images/success-circle-2.svg`;
  const imgSize = 30;

  const renderType = () => {
    switch (props.type) {
      case "info":
        return styles["upgrade-check-bar-info"];
      default:
        return styles["upgrade-check-bar-success"];
    }
  };
  const bannerTypeClass = renderType();

  return (
    <div
      className={`d-flex ${styles["upgrade-check-bar"]} ${bannerTypeClass} ${
        props.className ? " " + props.className : ""
      }`}
    >
      <div className="d-flex">
        <img src={imgUrl} width={imgSize} height={imgSize} />
        <span className={`${styles.message}`}>{props.message}</span>
      </div>
      {props.btnLabel && (
        <CTAButton
          className={`${styles.ctaBtn} p-0`}
          variant={"link white"}
          handleClick={props.btnHandler}
          id={props.id}
        >
          <span className="d-none d-md-inline-block">{props.btnLabel}</span>
        </CTAButton>
      )}
    </div>
  );
};

UpgradeCheckBar.defaultProps = {
  className: "",
  type: "success",
};

UpgradeCheckBar.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
  btnLabel: PropTypes.string,
  btnHandler: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.oneOf(["success", "info"]),
};

export default UpgradeCheckBar;
